var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}


class ProductCard extends HTMLElement {}
customElements.define("product-card", ProductCard);

class PriceSlider extends HTMLElement {
  constructor() {
    super();
    this.priceSlider = null;
    this.minInput = null;
    this.maxInput = null;
    this.hiddenMinInput = null;
    this.hiddenMaxInput = null;
    this.rangeText = null;
    this.rangeMin = 0;
    this.rangeMax = 0;
    this.currentMin = 0;
    this.currentMax = 0;
    this.updateTimeout = null;
    this.lastSubmittedMin = 0;
    this.lastSubmittedMax = 0;
  }

  connectedCallback() {
    this.priceSlider = this.querySelector('.filter-price-slider');
    this.minInput = this.querySelector('.price-input.min-price');
    this.maxInput = this.querySelector('.price-input.max-price');
    this.hiddenMinInput = this.querySelector('.filter-price--min');
    this.hiddenMaxInput = this.querySelector('.filter-price--max');
    this.rangeText = this.querySelector('.filter-price-range');

    this.rangeMin = parseFloat(this.priceSlider.dataset.rangemin) || 0;
    this.rangeMax = parseFloat(this.priceSlider.dataset.rangemax) || 1000;

    this.currentMin = this.minInput.value ?
      Math.max(this.rangeMin, parseFloat(this.minInput.value)) : this.rangeMin;
    this.currentMax = this.maxInput.value ?
      Math.min(this.rangeMax, parseFloat(this.maxInput.value)) : this.rangeMax;

    if (this.currentMin > this.currentMax) {
      this.currentMin = this.rangeMin;
      this.currentMax = this.rangeMax;
    }

    this.lastSubmittedMin = this.currentMin;
    this.lastSubmittedMax = this.currentMax;

    this.minInput.value = Math.round(this.currentMin);
    this.maxInput.value = Math.round(this.currentMax);
    this.updateRangeText();
    this.setupEventListeners();

    // Poll until theme.js (deferred) creates the noUiSlider instance,
    // then subscribe to sync visible inputs. Works for both first page load
    // (where defer scripts run after this custom element upgrades) and AJAX
    // re-renders (where theme.js._refresh already ran before this fires).
    const pollForSlider = (retries = 0) => {
      if (this.priceSlider.noUiSlider) {
        this.initializeSlider();
      } else if (retries < 40) {
        setTimeout(() => pollForSlider(retries + 1), 50);
      }
    };
    setTimeout(pollForSlider, 0);
  }

  initializeSlider() {
    const vals = this.priceSlider.noUiSlider.get();
    this.currentMin = Math.round(parseFloat(vals[0]));
    this.currentMax = Math.round(parseFloat(vals[1]));
    this.lastSubmittedMin = this.currentMin;
    this.lastSubmittedMax = this.currentMax;
    this.minInput.value = this.currentMin;
    this.maxInput.value = this.currentMax;

    this.priceSlider.noUiSlider.on('update', (values) => {
      const newMin = Math.round(parseFloat(values[0]));
      const newMax = Math.round(parseFloat(values[1]));

      this.currentMin = newMin;
      this.currentMax = newMax;
      this.minInput.value = newMin;
      this.maxInput.value = newMax;

      this.updateRangeText();
      this.updateHiddenInputs();
    });
  }

  setupEventListeners() {
    this.minInput.addEventListener('change', () => this.handleInputChange());
    this.maxInput.addEventListener('change', () => this.handleInputChange());
    
    this.minInput.addEventListener('keyup', (e) => {
      if (e.key === 'Enter') this.handleInputChange();
    });
    
    this.maxInput.addEventListener('keyup', (e) => {
      if (e.key === 'Enter') this.handleInputChange();
    });
  }

  handleInputChange() {
    let newMin = parseInt(this.minInput.value) || this.rangeMin;
    let newMax = parseInt(this.maxInput.value) || this.rangeMax;

    newMin = Math.max(this.rangeMin, Math.min(newMin, this.rangeMax));
    newMax = Math.min(this.rangeMax, Math.max(newMax, this.rangeMin));

    if (newMin > newMax) {
      if (document.activeElement === this.minInput) {
        newMin = this.currentMin;
        this.minInput.value = this.currentMin;
      } else {
        newMax = this.currentMax;
        this.maxInput.value = this.currentMax;
      }
      return;
    }

    this.currentMin = newMin;
    this.currentMax = newMax;

    if (this.priceSlider.noUiSlider) {
      this.priceSlider.noUiSlider.set([this.currentMin, this.currentMax]);
    }

    this.updateRangeText();
    this.updateHiddenInputs();
  }

  updateRangeText() {
    if (this.rangeText) {
      this.rangeText.textContent = `${this.currentMin} - ${this.currentMax}`;
    }
  }

  updateHiddenInputs() {
    this.hiddenMinInput.value = this.currentMin;
    this.hiddenMaxInput.value = this.currentMax;

    clearTimeout(this.updateTimeout);
    this.updateTimeout = setTimeout(() => {
      if (this.currentMin !== this.lastSubmittedMin || this.currentMax !== this.lastSubmittedMax) {
        this.lastSubmittedMin = this.currentMin;
        this.lastSubmittedMax = this.currentMax;
        this.dispatchFormUpdate();
      }
    }, 1000);
  }

  dispatchFormUpdate() {
    const event = new Event('input', {
      bubbles: true,
      cancelable: true,
    });
    const form = this.closest('form');
    if (form) {
      form.dispatchEvent(event);
    }
  }

  disconnectedCallback() {}
}

customElements.define('price-slider', PriceSlider);

document.addEventListener("DOMContentLoaded", () => {
  function triggerCollectionFiltersOverlay() {
    if (window.innerWidth <= 991) {
      const collectionFiltersDropdown = document.querySelectorAll('.collection-page--filters-drop');
      const header = document.querySelector('.cstm-header');
      if (collectionFiltersDropdown && header) {
        collectionFiltersDropdown.forEach(dropdown => {
          dropdown.addEventListener('click', () => {
            setTimeout(() => {
              // Only lower z-index if mobile menu is NOT open
              const mobileMenu = document.querySelector('mobile-menu');
              const menuOpen = mobileMenu && mobileMenu.querySelector('.header--mobile-menu--close')?.style.display === 'flex';
              if (!menuOpen) {
                header.style.zIndex = dropdown.open ? '0' : '';
              }
            }, 1);
          });
        });
      }
    }
  }

  triggerCollectionFiltersOverlay();
  window.addEventListener("resize",() => {
    triggerCollectionFiltersOverlay();
  });

  /* WCAG 1.4.13 — dismiss tooltips with Escape key */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.has-tooltip .tooltip').forEach(function(tip) {
        tip.style.visibility = 'hidden';
      });
    }
  });
});

/* ── Active filters: remove individual filter tag without page reload ── */
document.addEventListener('click', (e) => {
  const removeBtn = e.target.closest('.active-filters__remove');
  if (!removeBtn) return;

  const form = document.getElementById('CollectionFiltersForm');
  if (!form) return;

  e.preventDefault();

  if (removeBtn.dataset.filterType === 'price_range') {
    // Clear price range hidden inputs
    const minInput = form.querySelector('.filter-price--min');
    const maxInput = form.querySelector('.filter-price--max');
    if (minInput) minInput.value = '';
    if (maxInput) maxInput.value = '';

    // Reset noUiSlider to full range if initialized
    const slider = form.querySelector('.filter-price-slider');
    if (slider && slider.noUiSlider) {
      const rmin = parseInt(slider.dataset.rangemin, 10);
      const rmax = parseInt(slider.dataset.rangemax, 10);
      slider.noUiSlider.set([rmin, rmax]);
    }
  } else {
    // Uncheck the matching checkbox in the filter form
    const paramName = removeBtn.dataset.paramName;
    const paramValue = removeBtn.dataset.paramValue;
    const input = form.querySelector(
      `input[type="checkbox"][name="${paramName}"][value="${paramValue}"]`
    );
    if (input) {
      input.checked = false;
      input.closest('.filter-tag')?.classList.remove('active');
    }
  }

  // Trigger the existing AJAX filter handler
  form.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
});
